'use client';

import { SWRConfig } from 'swr';

import fetcherLib from 'commons/fetcher';

const fetcher = (url, options) => fetchWithTimeout(fetcherLib, [url, options]);

// This provider allows us to configure the SWR library with useful defaults
// such as a custom fetcher, and to preload specific responses from the server
// by using the fallback object.
const SWRClientProvider = ({ children, fallback }) => (
  <SWRConfig
    value={{
      fallback,
      fetcher,
    }}
  >
    {children}
  </SWRConfig>
);

export default SWRClientProvider;
